module.exports = __webpack_public_path__ + "img/design_design_tiradas.ae2c70fe.jpg";